import { render, staticRenderFns } from "./DiagnosticDetail.vue?vue&type=template&id=201574d8&scoped=true&"
import script from "./DiagnosticDetail.vue?vue&type=script&lang=js&"
export * from "./DiagnosticDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticDetail.vue?vue&type=style&index=0&id=201574d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201574d8",
  null
  
)

export default component.exports